<template>
  <div v-if="$store.getters.getIsCMUsers">
    <v-menu offset-y width="400">
      <template v-slot:activator="{ on: menu, attrs }">
        <v-btn
          dark
          elevation="0"
          v-bind="attrs"
          v-on="{ ...menu }"
          small
          class="px-0"
          color="blue"
        >
          <v-icon class="pr-1 material-symbols-outlined" size="18">
            person_edit
          </v-icon>
          <span class="subtitle-1">New Request Form</span>
        </v-btn>
      </template>

      <v-list dense>
        <div v-for="(item, index) in items" :key="index">
          <v-divider v-if="index > 0" />
          <v-list-item :to="item.route" @click="checkRequestType(item)">
            <v-list-item-icon>
              <v-icon color="green" class="material-symbols-outlined">{{
                item.icon
              }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title
                ><span class="request-link">{{
                  item.title
                }}</span></v-list-item-title
              >
            </v-list-item-content>
            <v-list-item-action></v-list-item-action>
          </v-list-item>
        </div>
      </v-list>
    </v-menu>
    <span style="color: white; margin: 0 5px">|</span>
    <v-dialog v-model="addCategory" max-width="600">
      <v-card>
        <v-card-title>
          <v-row class="row-class">
            <v-col cols="12" sm="10" md="10">
              <span>Add Category</span>
            </v-col>
          </v-row>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :ripple="false"
                icon
                color="magenta"
                small
                v-bind="attrs"
                v-on="on"
                @click="addCategory = false"
              >
                <v-icon>mdi-close-box</v-icon>
              </v-btn>
            </template>
            <span> Close</span>
          </v-tooltip>
        </v-card-title>

        <v-form ref="categoryForm" v-model="valid" lazy-validation>
          <v-card-text class="pt-5 pb-0">
            <span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="categoryName"
                    required
                    :rules="rules.categoryName"
                    class="search-class pa-0"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <template v-slot:label>
                      <span class="red-asterisk"> * </span>
                      <span>Category Name </span>
                    </template></v-text-field
                  >
                </template>
                <span>
                  Enter the name of Category Ex. Technical Materials
                </span>
              </v-tooltip>
            </span>

            <span>
              <v-textarea
                rows="3"
                maxlength="300"
                v-model="categoryBusinessJustification"
                required
                :rules="rules.categoryBusinessJustification"
                class="no-bg-color custom-label-color"
              >
                <template v-slot:label>
                  <span class="red-asterisk"> * </span>
                  <span> Business Justification </span>
                </template>
              </v-textarea>
            </span>
          </v-card-text>
          <v-card-actions>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="addCategory = false"
                  :ripple="false"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  color="blue"
                >
                  <span class="material-symbols-outlined"> arrow_back </span>
                </v-btn>
              </template>
              <span>Back</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="requestCategory"
                  :ripple="false"
                  color="green"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  :disabled="$store.getters.getIsSubmitting"
                >
                  <span class="material-symbols-outlined">check</span>
                </v-btn>
              </template>
              <span>Submit</span>
            </v-tooltip>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addCommodity" max-width="600">
      <v-card>
        <v-card-title>
          <v-row class="row-class">
            <v-col cols="12" sm="10" md="10">
              <span>Add Commodity</span>
            </v-col>
          </v-row>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :ripple="false"
                icon
                color="magenta"
                small
                v-bind="attrs"
                v-on="on"
                @click="addCommodity = false"
              >
                <v-icon>mdi-close-box</v-icon>
              </v-btn>
            </template>
            <span> Close</span>
          </v-tooltip>
        </v-card-title>

        <v-form ref="commodityForm" v-model="valid" lazy-validation>
          <v-card-text class="pt-5 pb-0">
            <span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-autocomplete
                    class="no-bg-color custom-label-color"
                    item-value="id"
                    required
                    v-model="categoryId"
                    :rules="rules.categoryId"
                    item-text="categoryName"
                    :items="categoryList"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <template v-slot:label>
                      <span class="red-asterisk"> * </span>
                      <span>Category </span>
                    </template>
                  </v-autocomplete>
                </template>
                <span>
                  Enter the name of Category Ex. Technical Materials
                </span>
              </v-tooltip>
            </span>
            <span>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="commodityName"
                    required
                    :rules="rules.commodityName"
                    class="pa-0"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <template v-slot:label>
                      <span class="red-asterisk"> * </span>
                      <span>Commodity Name </span>
                    </template></v-text-field
                  >
                </template>
                <span>
                  Enter the Commodity by Taxonomy Ex. Maintenance & Construction
                </span>
              </v-tooltip>
            </span>
            <span>
              <v-textarea
                rows="3"
                maxlength="300"
                required
                v-model="commodityBusinessJustification"
                :rules="rules.commodityBusinessJustification"
                class="no-bg-color custom-label-color"
              >
                <template v-slot:label>
                  <span class="red-asterisk"> * </span>
                  <span>Business Justification</span>
                </template>
              </v-textarea>
            </span>
          </v-card-text>
          <v-card-actions>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="addCommodity = false"
                  :ripple="false"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  color="blue"
                >
                  <span class="material-symbols-outlined"> arrow_back </span>
                </v-btn>
              </template>
              <span>Back</span>
            </v-tooltip>
            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="requestCommodity"
                  :ripple="false"
                  color="green"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  :disabled="$store.getters.getIsSubmitting"
                >
                  <span class="material-symbols-outlined">check</span>
                </v-btn>
              </template>
              <span>Submit</span>
            </v-tooltip>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import requestsMixin from "../mixins/requests-mixin";
import appMixin from "../mixins/app-mixin";
import axios from "axios";
export default {
  mixins: [requestsMixin, appMixin],
  name: "DialogScrollable",
  components: {},
  computed: {},
  data() {
    return {
      items: [
        {
          title: "Request for Category",
          value: "requestCategory",
          icon: "add_circle",
        },
        {
          title: "Request for Commodity",
          value: "requestCommodity",
          icon: "add_circle",
        },
        {
          title: "Request for Segment",
          value: "requestSegment",
          icon: "add_circle",
        },
      ],
      addCategory: false,
      categoryName: "",
      categoryFile: null,
      categoryImage: "",
      regionId: "",
      categoryBusinessJustification: "",
      valid: true,
      addCommodity: false,
      categoryList: [],
      categoryId: 0,
      commodityName: "",
      commodityBusinessJustification: "",
      rules: {
        categoryName: [
          (v) => !!v || "Category name is required",

          (v) => {
            let isExisting = true;
            if (v != null && v.length > 0) {
              let ts = this;
              ts.isExisting = this.categoryList.some(
                (category) =>
                  category.categoryName.toLowerCase().trim() ===
                  v.toLowerCase().trim()
              );
            }
            return !this.isExisting || "Category name already exists";
          },
        ],
        categoryBusinessJustification: [
          (v) => !!v || "Business Justification is required",
        ],
        categoryId: [(v) => !!v || "Category is required"],
        commodityName: [(v) => !!v || "Commodity Name is required"],
        commodityBusinessJustification: [
          (v) => !!v || "Business Justification is required",
        ],
        file: [(v) => !!v || "Category Image is required"],
      },
    };
  },
  methods: {
    selectCategoryImage() {
      var ts = this;
      if (ts.categoryFile != null) {
        const blobUrl = URL.createObjectURL(ts.categoryFile); // to show add time image preview
        ts.categoryImage = blobUrl;
      } else {
        ts.categoryImage = "";
      }
    },
    checkRequestType(item) {
      if (item.value == "requestCategory") {
        this.addCategoryMethod();
      }
      if (item.value == "requestCommodity") {
        this.addCommodityMethod();
      }
      if (item.value == "requestSegment") {
        let requestSegment = true;
        this.$store.dispatch("updateRequestSegment", requestSegment);
        this.$store.dispatch("updateEditId", null);
        this.$router.push("/segmentform");
      }
    },
    addCategoryMethod() {
      this.categoryName = "";
      this.addCategory = !this.addCategory;
      this.getCategoryList();
      this.$refs.categoryForm.reset();
    },
    addCommodityMethod() {
      this.commodityName = "";
      this.addCommodity = !this.addCommodity;
      this.getCategoryList();
      this.$refs.commodityForm.reset();
    },
    async getCategoryList() {
      var ts = this;
      ts.regionId = JSON.parse(localStorage.getItem("selectedRegion"));
      await axios({
        method: "get",
        url:
          ts.settings.apiUrl +
          "/Category/GetCategories?regionId=" +
          ts.regionId +
          "&status=0",
      })
        .then(function (response) {
          ts.categoryList = response.data;
        })
        .catch(function (error) {
          console.log("Error! Could not reach the API. " + error);
        });
    },
    async requestCategory() {
      if (this.$refs.categoryForm.validate()) {
        var ts = this;

        const categoryData = new FormData();
        categoryData.append("Id", 0);
        categoryData.append("CategoryName", ts.categoryName);
        categoryData.append("ParentCategoryId", 0);
        categoryData.append("Region", ts.regionId);
        categoryData.append(
          "CreatedBy",
          ts.$store.getters.getUserDetail.userEmail
        );
        categoryData.append("CreatedDateTime", new Date().toISOString());
        categoryData.append(
          "BusinessJustification",
          ts.categoryBusinessJustification
        );

        categoryData.append("IsDeleted", false);
        categoryData.append("Status", 1);
        categoryData.append("RejectReason", "");
        categoryData.append("Notes", "");
        categoryData.append("Icon", null);
        categoryData.append("file", ts.categoryFile);

        await axios
          .post(ts.settings.apiUrl + "/Category/AddCategory", categoryData, {
            headers: {
              Accept: "application/json",
              "Content-type": "multipart/form-data",
            },
          })
          .then(function (response) {
            ts.addCategory = false;

            ts.getCategoryList();
          })
          .catch(function (error) {
            console.log("Error! Could not reach the API. " + error);
          });
      }
    },
    async requestCommodity() {
      if (this.$refs.commodityForm.validate()) {
        var ts = this;
        var categoryName = ts.categoryList
          .filter((w) => w.id == ts.categoryId)
          .map((category) => category.categoryName)
          .join(", ");
        let newCommodity = {
          id: 0,
          name: ts.commodityName,
          categoryId: ts.categoryId,
          createdBy: ts.$store.getters.getUserDetail.userEmail,
          createdDateTime: new Date().toISOString(),
          isDeleted: false,
          status: 1,
          rejectReason: "",
          notes: "",
          businessJustification: ts.commodityBusinessJustification,
          categoryName: categoryName,
        };

        await axios({
          method: "post",
          url: ts.settings.apiUrl + "/Commodity/AddCommodity",
          data: newCommodity,
        })
          .then(function (response) {
            ts.addCommodity = false;
          })
          .catch(function (error) {
            console.log("Error! Could not reach the API. " + error);
          });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.red-asterisk {
  color: red;
  font-size: larger;
}
.image-size {
  height: 64px;
  width: 64px;
}
</style>
